import { Component } from '@angular/core';

@Component({
  selector: 'knx-page-subtitle',
  host: {
    class: 'block text-sm text-muted-foreground',
  },
  templateUrl: './page-subtitle.component.html',
})
export class PageSubtitleComponent {}
